

import { deleteImage } from '../api/imageApi';

/**
 * Deletes images that are no longer present in the updated URL list.
 * This function runs asynchronously and is designed to be non-blocking.
 *
 * @param {string[]} originalUrls - The original list of image URLs.
 * @param {string[]} updatedUrls - The updated list of image URLs after form edit.
 */
export const deleteRemovedImages = async (originalUrls, updatedUrls) => {
  const deletedImages = originalUrls.filter(
    (url) => !updatedUrls.includes(url) && url.includes('res.cloudinary.com')
  );

  for (const url of deletedImages) {
    const segments = url.split('/');
    const publicId = segments.slice(segments.indexOf('upload') + 1).join('/').split('.')[0];

    try {
      const res = await deleteImage(publicId);
      console.log('🗑️ Deleted image from Cloudinary (background):', res);
    } catch (err) {
      console.error('❌ Failed to delete image (background):', err);
    }
  }
};